<template>
  <div :class="['definition-wrapper', 'numInterval', definition.id, {'error_validate': mandatoryValidation || validation}]">
    <div v-if="editable">
      <vue-slider
        :min="definition.validation.format.lengthMin"
        :max="definition.validation.format.lengthMax"
        :lazy="true"
        :enable-cross="true"
        :tooltip="'always'"
        :tooltip-placement="['bottom', 'bottom']"
        v-model="numIntervalValue"
        @change="valueChanged"
      />
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import moment from 'moment'
import transport from 'vue-definition-utils/src/utils/transport'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'definition-num-interval',
  components: {
    DefinitionReadOnly,
    VueSlider
  },
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'placeholder',
    'callTask'
  ],
  data () {
    return {
      numIntervalValue: [],
      validation: null
    }
  },
  beforeMount () {
    this.numIntervalValue = this.getNumIntervalValue()
    this.setNumIntervalValue()
  },
  methods: {
    // 1. Launch validate mandatory event on date change
    valueChanged (event) {
      this.setNumIntervalValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    validateNumIntervalFormat () {
      var value = this.getNumIntervalValue()
      if (value && value.length > 0) {
        // 3. if date format validation past...
        var errorFound = false
        for (var j = 0; j < value.length && !errorFound; j++) {
          this.validation = transport.methods.validateNumIntervalFormat(this.definition, value[j])
          if (this.validation) {
            errorFound = true
          }
        }
        if (!errorFound) {
          // ... and launch refresh definition event
          this.$emit('refreshDefinition', this.object)
        } else {
          // ... or launch date interval format error event to show error message
          this.$emit('numIntervalFormatError', moment().valueOf(), this.validation, this.definition.validation.format)
        }
      } else {
        this.$emit('refreshDefinition', this.object)
      }
    },
    getNumIntervalValue () {
      var result = []
      if (this.object.textValue && this.object.textValue !== '') {
        var myRegexp = /\[([^\]]+)\]/g
        var match = myRegexp.exec(this.object.textValue)
        while (match) {
          var value = match[1]
          result.push(parseInt(value))
          match = myRegexp.exec(this.object.textValue)
        }
      } else {
        result.push(0)
        result.push(1)
      }
      return result
    },
    setNumIntervalValue () {
      var value = this.numIntervalValue
      this.object.textValue = null
      if (value && value.length > 0) {
        var errorFound = false
        for (var j = 0; j < value.length && !errorFound; j++) {
          this.validation = transport.methods.validateNumIntervalFormat(this.definition, value[j])
          if (!this.validation) {
            // ... set num interval value
            var objNumIntervalValue = `[${value[j]}]`
            if (!this.object.textValue) {
              this.object.textValue = objNumIntervalValue
            } else {
              this.object.textValue += objNumIntervalValue
            }
          } else {
            errorFound = true
          }
        }
        if (errorFound) {
          this.object.textValue = null
        }
      }
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (!value.validateKey || value.validateKey.trim() === '')) {
        // ... launch date interval format validation
        this.validateNumIntervalFormat()
      }
    },
    object (value) {
      this.numIntervalValue = this.getNumIntervalValue(value)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/numInterval.vue